import type { MyProfileWorkspace } from '@onestep/camel-api';
import { parseAsString, useQueryState } from 'nuqs';
import { useLocation } from 'react-router';

import { clearSelectedClinicUuid, getSelectedClinicUuid } from '../../Pages/selected-clinic-cookie';
import useStores from '../useStores';

const PATIENT_LIST_PATH = '/patients';

const resolveSelectedWorkspaceUuid = (
  workspaces: MyProfileWorkspace[],
  requestedWorkspaceUuids: (string | null | undefined)[],
): string | undefined =>
  requestedWorkspaceUuids.find((requested) =>
    workspaces.some((workspace) => workspace.uuid === requested),
  ) ?? workspaces[0]?.uuid;

export function useSelectedWorkspaceReconciler(): {
  reconcileSelectedWorkspace(workspaces: MyProfileWorkspace[]): void;
} {
  const { appStore } = useStores();
  const { pathname } = useLocation();
  const [clinicUuidParam] = useQueryState('clinic_uuid', parseAsString);
  const linkedWorkspaceUuid = pathname === PATIENT_LIST_PATH ? clinicUuidParam : null;

  return {
    reconcileSelectedWorkspace(workspaces) {
      const workspaceUuid = resolveSelectedWorkspaceUuid(workspaces, [
        linkedWorkspaceUuid,
        getSelectedClinicUuid(),
      ]);
      if (workspaceUuid) {
        appStore.setClinic(workspaceUuid);
      } else {
        clearSelectedClinicUuid();
      }
    },
  };
}
